import { LoopscalePointsAction, LendingVaultExpanded } from "@bridgesplit/abf-react";
import { TextColor, TextVariant } from "@bridgesplit/ui";
export type GenericRewardsApyProps = {
    apy: number | undefined;
    loopscalePointsAction: LoopscalePointsAction;
    identifier: string | undefined;
    rateDisplayTextVariant?: TextVariant;
    rateDisplayColor?: TextColor;
    hideApyText?: boolean;
};

export type RewardsPortfolioBorrowApyProps = GenericRewardsApyProps & {
    customDailyPoints: number | undefined;
    lendingVaultExpanded?: LendingVaultExpanded | undefined;
    isBorrower: boolean;
    /**
     * Optional server-stamped total APY (e.g. from /lending_vaults/user). When provided,
     * overrides the internal client-side `useVaultApyBreakdown` for the top-line display only;
     * tooltip breakdown continues to use the client breakdown until that path is also migrated.
     */
    totalApy?: number;
};

/**
 * This is a constant value that is used to calculate the principal borrowed with leverage.
 * It is used to accuratley display max leverage points based on quotes.
 * It can be changed to any value, but should be consistent with how much $ per point is used in the UI.
 */
export const POINT_BASIS = 1000;
